import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Pre-Contractual Checks\n          ")
], -1);
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "Please note a start date cannot be confirmed unlessthe preliminary checks are complete and we may needto return the ATR to you whilst the checks are beingcompleted.", -1);
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-blue-500" }, "\n            If the employee starts before BACS processing day, and so long as the completed ATR and supporting documentation is\n            received by the HR deadline they can go on for the current month's/week's pay day.\n        ", -1);
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
import { computed, toRef } from 'vue';
import { useStore } from 'vuex';
import { CheckList, Input, Radio } from '@/form';
export default /*#__PURE__*/ _defineComponent({
    __name: 'preContractual',
    props: {
        formData: {},
        disableForm: { type: Boolean },
        document: {}
    },
    emits: ["update:formData", "submit-form"],
    setup(__props, { emit: __emit }) {
        const store = useStore();
        const props = __props;
        const emit = __emit;
        const model = toRef(props, 'formData');
        const profile = computed(() => store.getters.getProfile);
        const security_check = Input('Is a Security Check (BS7858) Required?', 'security_check', 'text', props.disableForm, model.value?.security_check);
        const security_clearance = Input('Have the preliminary checks been carried out forBS7858 Security Clearance? ', 'security_clearance', 'text', props.disableForm, model.value?.security_clearance);
        const security_sia = Radio('Is a Security Industry Authority Licence (SIA) Required?', 'security-lisense', undefined, undefined, props.disableForm, model.value?.security_sia);
        const hr_deadlines = CheckList('', [
            "Please be sure to check the HR deadlines to manage the employee's expectations for their first pay day.",
        ], props.disableForm, model.value?.confirm);
        const submitForm = async () => {
            // Get input elements
            const securtyCheckInput = document.getElementById('security_check');
            const securityClearanceInput = document.getElementById('security_clearance');
            const securityLisenseYesInput = document.getElementById('radio_button_security-lisense_Yes');
            const securityLisenseNoInput = document.getElementById('radio_button_security-lisense_No');
            const confirm = document.getElementById('please-be-sure-to-check-the-hr-deadlines-to-manage-the-employees-expectations-for-their-first-pay-day-check');
            // Set formData with input values from fields
            if (securtyCheckInput)
                model.value.security_check = securtyCheckInput.value;
            if (securityClearanceInput)
                model.value.security_clearance = securityClearanceInput.value;
            if (securityLisenseYesInput?.checked)
                model.value.security_sia = securityLisenseYesInput.value;
            else if (securityLisenseNoInput?.checked)
                model.value.security_sia = securityLisenseNoInput.value;
            if (confirm?.checked)
                model.value.confirm = 'TRUE';
            await emit('update:formData', { formName: 'checks', formData: model.value });
            emit('submit-form', { name: 'checks', data: model.value });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(security_check) }, null, 8, _hoisted_5),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(security_clearance) }, null, 8, _hoisted_6),
                        _createTextVNode(),
                        _hoisted_7,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(security_sia) }, null, 8, _hoisted_8),
                        _createTextVNode(),
                        _hoisted_9,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(hr_deadlines) }, null, 8, _hoisted_10)
                    ]),
                    _createTextVNode(),
                    (profile.value?.H2R && _ctx.document.currentStageName === 'offer.notifyMakeOffer')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                onClick: _withModifiers(submitForm, ["prevent"])
                            }, "\n          Confirm offer has been sent\n        ")
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
